import { render, staticRenderFns } from "./content-room.vue?vue&type=template&id=58c735b4&"
import script from "./content-room.vue?vue&type=script&lang=js&"
export * from "./content-room.vue?vue&type=script&lang=js&"
import style0 from "./content-room.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports